import React from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import { ThemeModeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';

import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import HadithListPage from './pages/hadith/HadithListPage';
import HadithFormPage from './pages/hadith/HadithFormPage';
import DuaListPage from './pages/duas/DuaListPage';
import DuaFormPage from './pages/duas/DuaFormPage';
import CategoryManagerPage from './pages/categories/CategoryManagerPage';
import QuoteListPage from './pages/quotes/QuoteListPage';
import QuoteFormPage from './pages/quotes/QuoteFormPage';
import UserListPage from './pages/users/UserListPage';
import BannerListPage from './pages/banners/BannerListPage';
import BannerFormPage from './pages/banners/BannerFormPage';
import TasbeehListPage from './pages/tasbeeh/TasbeehListPage';
import TasbeehFormPage from './pages/tasbeeh/TasbeehFormPage';
import ProphetListPage from './pages/prophets/ProphetListPage';
import ProphetFormPage from './pages/prophets/ProphetFormPage';
import ProphetChapterListPage from './pages/prophets/ProphetChapterListPage';
import ProphetChapterFormPage from './pages/prophets/ProphetChapterFormPage';
import NotificationListPage from './pages/notifications/NotificationListPage';
import NotificationFormPage from './pages/notifications/NotificationFormPage';
import WebNotificationFormPage from './pages/notifications/WebNotificationFormPage';
import GalleryListPage from './pages/gallery/GalleryListPage';
import MaintenancePage from './pages/MaintenancePage';
import AppVersionPage from './pages/version/AppVersionPage';
import CampaignListPage from './pages/campaigns/CampaignListPage';
import CampaignFormPage from './pages/campaigns/CampaignFormPage';
import QuranListPage from './pages/quran/QuranListPage';
import SurahDetailPage from './pages/quran/SurahDetailPage';
import FeedbackListPage from './pages/feedback/FeedbackListPage';
import MessageListPage from './pages/messages/MessageListPage';
import TicketListPage from './pages/tickets/TicketListPage';
import AdminUserListPage from './pages/admin-users/AdminUserListPage';

function App() {
  return (
    <ThemeModeProvider>
      <BrowserRouter>
        <AuthProvider>
          <Switch>
            <Route exact path="/login" component={LoginPage} />
            <PrivateRoute exact path="/dashboard"          permissionKey="dashboard"     component={DashboardPage} />
            <PrivateRoute exact path="/campaigns"          permissionKey="banners"       component={CampaignListPage} />
            <PrivateRoute exact path="/campaigns/create"   permissionKey="banners"       component={CampaignFormPage} />
            <PrivateRoute exact path="/campaigns/edit/:id" permissionKey="banners"       component={CampaignFormPage} />
            <PrivateRoute exact path="/quran"              permissionKey="quran"         component={QuranListPage} />
            <PrivateRoute exact path="/quran/:id"          permissionKey="quran"         component={SurahDetailPage} />
            <PrivateRoute exact path="/hadith"             permissionKey="hadith"        component={HadithListPage} />
            <PrivateRoute exact path="/hadith/create"      permissionKey="hadith"        component={HadithFormPage} />
            <PrivateRoute exact path="/hadith/edit/:id"    permissionKey="hadith"        component={HadithFormPage} />
            <PrivateRoute exact path="/duas"               permissionKey="duas"          component={DuaListPage} />
            <PrivateRoute exact path="/duas/create"        permissionKey="duas"          component={DuaFormPage} />
            <PrivateRoute exact path="/duas/edit/:id"      permissionKey="duas"          component={DuaFormPage} />
            <PrivateRoute exact path="/banners"            permissionKey="banners"       component={BannerListPage} />
            <PrivateRoute exact path="/banners/create"     permissionKey="banners"       component={BannerFormPage} />
            <PrivateRoute exact path="/banners/edit/:id"   permissionKey="banners"       component={BannerFormPage} />
            <PrivateRoute exact path="/tasbeeh"            permissionKey="tasbeeh"       component={TasbeehListPage} />
            <PrivateRoute exact path="/tasbeeh/create"     permissionKey="tasbeeh"       component={TasbeehFormPage} />
            <PrivateRoute exact path="/tasbeeh/edit/:id"   permissionKey="tasbeeh"       component={TasbeehFormPage} />
            <PrivateRoute exact path="/prophets"           permissionKey="prophets"      component={ProphetListPage} />
            <PrivateRoute exact path="/prophets/create"    permissionKey="prophets"      component={ProphetFormPage} />
            <PrivateRoute exact path="/prophets/edit/:id"  permissionKey="prophets"      component={ProphetFormPage} />
            <PrivateRoute exact path="/prophets/:prophetId/chapters" permissionKey="prophets" component={ProphetChapterListPage} />
            <PrivateRoute exact path="/prophets/:prophetId/chapters/create" permissionKey="prophets" component={ProphetChapterFormPage} />
            <PrivateRoute exact path="/prophets/:prophetId/chapters/edit/:chapterId" permissionKey="prophets" component={ProphetChapterFormPage} />
            <PrivateRoute exact path="/categories"         permissionKey="categories"    component={CategoryManagerPage} />
            <PrivateRoute exact path="/quotes"             permissionKey="quotes"        component={QuoteListPage} />
            <PrivateRoute exact path="/quotes/create"      permissionKey="quotes"        component={QuoteFormPage} />
            <PrivateRoute exact path="/quotes/edit/:id"    permissionKey="quotes"        component={QuoteFormPage} />
            <PrivateRoute exact path="/users"              permissionKey="users"         component={UserListPage} />
            <PrivateRoute exact path="/notifications"      permissionKey="notifications" component={NotificationListPage} />
            <PrivateRoute exact path="/notifications/create" permissionKey="notifications" component={NotificationFormPage} />
            <PrivateRoute exact path="/web-notifications/create" permissionKey="notifications" component={WebNotificationFormPage} />
            <PrivateRoute exact path="/web-notifications/edit/:id" permissionKey="notifications" component={WebNotificationFormPage} />
            <PrivateRoute exact path="/gallery"            permissionKey="banners"       component={GalleryListPage} />
            <PrivateRoute exact path="/feedback"           permissionKey="feedback"      component={FeedbackListPage} />
            <PrivateRoute exact path="/messages"           permissionKey="messages"      component={MessageListPage} />
            <PrivateRoute exact path="/tickets"            permissionKey="tickets"       component={TicketListPage} />
            <PrivateRoute exact path="/maintenance"        permissionKey="maintenance"   component={MaintenancePage} />
            <PrivateRoute exact path="/app-version"         permissionKey="maintenance"   component={AppVersionPage} />
            <PrivateRoute exact path="/admin-users"        permissionKey="admin_users"   component={AdminUserListPage} />
            <Redirect from="/" to="/dashboard" />
          </Switch>
        </AuthProvider>
      </BrowserRouter>
    </ThemeModeProvider>
  );
}

export default App;
